var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "divBox",
    },
    [
      _c("search-page", {
        directives: [
          {
            name: "hasPermi",
            rawName: "v-hasPermi",
            value: ["platform:system:user:withdraw:integralList"],
            expression: "['platform:system:user:withdraw:integralList']",
          },
        ],
        ref: "searchPage",
        attrs: {
          "form-data": _vm.formData,
          columns: _vm.columns,
          request: _vm.getList,
        },
        scopedSlots: _vm._u([
          {
            key: "table-user",
            fn: function (ref) {
              var row = ref.row
              return [
                _c(
                  "div",
                  { staticClass: "acea-row row-middle" },
                  [
                    _c("el-image", {
                      staticClass: "mr8",
                      attrs: {
                        src: row.avatar,
                        "preview-src-list": [row.avatar],
                      },
                    }),
                    _c("div", [
                      _c("div", [_vm._v(_vm._s(row.nickname))]),
                      _c("div", [_vm._v(_vm._s(row.userPhone))]),
                      _c("div", { staticClass: "ivu-text-left" }, [
                        _vm._v("ID：" + _vm._s(row.uid)),
                      ]),
                    ]),
                  ],
                  1
                ),
              ]
            },
          },
          {
            key: "table-integral",
            fn: function (ref) {
              var row = ref.row
              return [
                _c("div", [
                  _vm._v(
                    " " +
                      _vm._s(row.type === 1 ? "+" : "-") +
                      _vm._s(row.integral) +
                      " "
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }